import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoginForm from "@/components/auth/LoginForm";
import { useAuth } from "@/contexts/AuthContext";

/** Set by ProtectedRoute so a successful login returns the user where they were. */
interface RedirectState {
  from?: { pathname?: string; search?: string; hash?: string };
}

function postLoginPath(
  defaultHomePath: string | undefined,
  from?: RedirectState["from"],
) {
  if (from?.pathname && from.pathname !== "/auth") {
    return `${from.pathname}${from.search ?? ""}${from.hash ?? ""}`;
  }
  return defaultHomePath || "/";
}

const Auth = () => {
  const { isAuthenticated, hasAccess, loading, session } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as RedirectState | null)?.from;
  const homePath = postLoginPath(session?.acuityLearn?.defaultHomePath, from);

  useEffect(() => {
    if (!loading && isAuthenticated && hasAccess) {
      navigate(homePath, { replace: true });
    }
  }, [loading, isAuthenticated, hasAccess, navigate, homePath]);

  return <LoginForm />;
};

export default Auth;
